import EmblaCarousel from 'embla-carousel';
import Autoplay from 'embla-carousel-autoplay';

document.addEventListener("DOMContentLoaded", function () {
    const heroSlider = document.querySelector('.hero-slider');
    if (heroSlider) {
        initSlider(heroSlider, { 
            loop: {
                delay: 5000,
                stopOnMouseEnter: true,
            },
            duration: 35,
            autoplay: true 
        });
    }
});

function initSlider(element, options) {
    const viewportNode = element.querySelector('.embla__viewport');
    const prevButtonNode = element.querySelector('.embla__prev');
    const nextButtonNode = element.querySelector('.embla__next');
    const dotsNode = element.querySelector('.embla__dots')
    const plugins = [Autoplay()];
    
    const embla = EmblaCarousel(viewportNode, options, plugins);
    
    if (prevButtonNode) {
        prevButtonNode.addEventListener('click', embla.scrollPrev, false);
    }
    if (nextButtonNode) {
        nextButtonNode.addEventListener('click', embla.scrollNext, false);
    }

    if (dotsNode) {
        const dots = Array.from(dotsNode.children);
        dots.forEach((dotNode, index) => {
            dotNode.addEventListener('click', () => embla.scrollTo(index), false);
        });
        embla.on('select', () => {
            const selectedDot = dots.find((dotNode, index) => index === embla.selectedScrollSnap());
            dots.forEach(dotNode => dotNode.classList.remove('is-selected'));
            selectedDot.classList.add('is-selected');
            }
        );
    }
    
    return embla;
}